import { render, staticRenderFns } from "./charge-record.vue?vue&type=template&id=10ca848b&scoped=true&"
import script from "./charge-record.vue?vue&type=script&lang=js&"
export * from "./charge-record.vue?vue&type=script&lang=js&"
import style0 from "./charge.scss?vue&type=style&index=0&id=10ca848b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ca848b",
  null
  
)

export default component.exports